/*
 * Griptec: Read more / Read less toggle for clamped short descriptions.
 * For each .product-short-description that is actually clamped (scrollHeight > clientHeight),
 * insert a toggle button after it. Labels come from data-more-label / data-less-label on the
 * description div (editable in the theme editor's custom-liquid field), with sensible fallbacks.
 */
(function () {
  'use strict';

  function init() {
    var descriptions = document.querySelectorAll('.product-short-description');

    descriptions.forEach(function (desc) {
      // Skip if a toggle was already added (e.g. re-init).
      if (desc.nextElementSibling && desc.nextElementSibling.classList.contains('g-readmore')) {
        return;
      }

      // Only add the toggle when the content is genuinely clamped/overflowing.
      if (desc.scrollHeight <= desc.clientHeight) {
        return;
      }

      var moreLabel = desc.getAttribute('data-more-label') || 'Read more';
      var lessLabel = desc.getAttribute('data-less-label') || 'Read less';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'g-readmore';
      button.setAttribute('aria-expanded', 'false');
      button.textContent = moreLabel;

      button.addEventListener('click', function () {
        var isOpen = desc.classList.toggle('is-open');
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        button.textContent = isOpen ? lessLabel : moreLabel;
      });

      desc.insertAdjacentElement('afterend', button);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
